export default __webpack_public_path__ + "static/media/1200px-La_conversion_de_Saint_Paul_Giordano_Nancy_3018.f232b7da.jpg";